module.exports = __webpack_public_path__ + "img/responsive hospitium-09.aac37e8e.jpg";